import React, { useState, useEffect } from 'react';
import { CircularProgress, Container, Paper, Grid, Typography, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
// import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
// import { AUTH_ACTION } from '../../../interface';
import { signin } from '../../../actions/auth';
import useStyles from './styles';
import useCommonStyles from '../../CommonStyle/commonStyle';
import Input from '../Input/Input';
import useMedia from "use-media";
import useCommonAuthStyles from '../commonAuthStyle';
import GoToTop from '../../Functional/GoToTop';
import PopupNotice from '../../PopupNotice/PopupNotice';
import { store } from '../../../index';


type RootState = ReturnType<typeof store.getState>;
const initialState = { email: '', password: '' };

const Login = () => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const commonAuthClasses = useCommonAuthStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const { isLoading, errors } = useSelector((state: RootState) => state.auth);
    console.log("inside login");

    const [form, setForm] = useState(initialState);
    const [showPassword, setShowPassword] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
    }, [isLoading]);
    useEffect(() => {
        console.log("enter useEffect popnotice");
        if (errors!=null){
        console.log("opening popnotice");
        setOpen(true);}
    }, [errors]);

    const handleShowPassword = () => setShowPassword((prevShowPassword) => (!prevShowPassword));

    const handleSubmitLogin = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log(e);
        dispatch(signin(form, history));
        
        console.log(JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}'));
        

    };


    //@ts-ignore
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, [e.target.name]: e.target.value });


    const isLarger500 = useMedia({ minWidth: "500px" });
    return (
        <Container maxWidth="lg" className={commonClasses.bodyContainer}>
            <Paper className={classes.paper} elevation={3}>
                <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={3} className={classes.parentGridContainer}>
                    <Grid item xs={12} sm={12} md={6} className={commonAuthClasses.leftGrid}>
                        <div className={classes.leftGridTypographies}>
                            <Typography className={commonAuthClasses.motivationalTitle} >
                                ログイン<br />
                            </Typography>
                            <Typography className={commonAuthClasses.subTitle}>
                                さぁ、プロジェクトを始めよう。
                            </Typography >
                        </div>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={6} className={commonAuthClasses.rightGrid} >

                        <form name="profileInfoForm" className={classes.form} onSubmit={handleSubmitLogin}>
                            <Grid container spacing={2}>
                                {isLarger500 ? <><div className={classes.height100}></div></> : <></>}


                                <Input name="email" label="メールアドレス" handleChange={handleChange} type="email" value={form.email} />
                                <Input
                                    name="password"
                                    label="パスワード"
                                    handleChange={handleChange}
                                    type={showPassword ? 'text' : 'password'}
                                    handleShowPassword={handleShowPassword}
                                    value={form.password} />
                                <br />
                                <Link to="/startup/signup" className={commonAuthClasses.hintLinkBtn}>新規登録されていない方はこちら</Link>
                            </Grid>
                            <Grid container alignItems="center" justifyContent="flex-end" className={classes.buttonsGrid}>

                                {/* <Button type="submit" variant="contained" color="primary" className={classes.submit} onClick={() => setNext(true)} > */}
                                {isLoading ?
                                    <Button variant="contained" color="primary" className={commonAuthClasses.submitLoading} >
                                        <CircularProgress size={24} className={commonAuthClasses.submitCircularProgress}/>
                                    </Button> :
                                    <Button type="submit" variant="contained" color="primary" className={commonAuthClasses.submit} >
                                        ログイン
                                    </Button>
                                }
                                {/* <Button type="submit" variant="contained" color="primary" className={commonAuthClasses.submit} >
                                        ログイン
                                    </Button>
                                {isLoading && (<CircularProgress className={commonAuthClasses.submit}/>) } */}
                            </Grid>

                        </form>
                    </Grid>

                </Grid>
                <PopupNotice setOpen={setOpen} open={open} message={errors} buttonLink="#" buttonText="戻る"/>
            </Paper>
            <GoToTop />
        </Container>
    )
}

export default Login;
